import React, { useState } from "react";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi2";
import Button from "../../common/Button/Button";
import "./Step3.scss";

const Step3 = ({ onNext, onBack, initialData }) => {
    const [formData, setFormData] = useState({
        areasToScan: initialData?.areasToScan || [],
        areasOther: initialData?.areasOther || "",
        disciplines: initialData?.disciplines || [],
        disciplinesOther: initialData?.disciplinesOther || "",
        scanningDeliverables: initialData?.scanningDeliverables || [],
        scanningOther: initialData?.scanningOther || "",
        bimDeliverables: initialData?.bimDeliverables || [],
        bimOther: initialData?.bimOther || "",
        additionalDetails: initialData?.additionalDetails || "",
    });

    const [errors, setErrors] = useState({});

    const areasOptions = [
        "Interior",
        "Fachada e inmediaciones",
        "Techo",
        "Espacio sobre techo",
        "Debajo del piso elevado",
        "Espacio de arrastre",
        "Sitio (calles, estacionamiento, etc.)",
        "Servicios subterráneos",
        "Otro",
    ];

    const disciplinesOptions = [
        "Arquitectura",
        "Estructura",
        "Mecánica",
        "Eléctrica",
        "Fontanería",
        "Protección contra incendios",
        "Sitio y Topografía",
        "Otro",
    ];

    const scanningDeliverablesOptions = [
        "Nube de puntos coloreada",
        "Nube de puntos escala de grises",
        "Vistas 360",
        "Fotogrametría",
        "Control de inspección",
        "Captura de datos de equipos",
        "Otro",
    ];

    const bimDeliverablesOptions = [
        "Escaneo a modelo BIM",
        "Planos As-built",
        "Etiquetado en modelos",
        "Otro",
    ];

    const handleCheckboxChange = (category, value) => {
        setFormData((prev) => {
            const currentArray = prev[category];
            const newArray = currentArray.includes(value)
                ? currentArray.filter((item) => item !== value)
                : [...currentArray, value];
            return { ...prev, [category]: newArray };
        });

        if (errors[category]) {
            setErrors((prev) => ({ ...prev, [category]: null }));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (formData.areasToScan.length === 0) {
            newErrors.areasToScan = "Selecciona al menos un área";
        }

        if (
            formData.areasToScan.includes("Otro") &&
            !formData.areasOther.trim()
        ) {
            newErrors.areasOther = "Especifica el área";
        }

        if (
            formData.disciplines.includes("Otro") &&
            !formData.disciplinesOther.trim()
        ) {
            newErrors.disciplinesOther = "Especifica la disciplina";
        }

        if (
            formData.scanningDeliverables.includes("Otro") &&
            !formData.scanningOther.trim()
        ) {
            newErrors.scanningOther = "Especifica el entregable";
        }

        if (
            formData.bimDeliverables.includes("Otro") &&
            !formData.bimOther.trim()
        ) {
            newErrors.bimOther = "Especifica el entregable BIM";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            onNext(formData);
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const isFormValid = () => {
        return (
            formData.areasToScan.length > 0 &&
            (!formData.areasToScan.includes("Otro") ||
                formData.areasOther.trim()) &&
            (!formData.disciplines.includes("Otro") ||
                formData.disciplinesOther.trim()) &&
            (!formData.scanningDeliverables.includes("Otro") ||
                formData.scanningOther.trim()) &&
            (!formData.bimDeliverables.includes("Otro") ||
                formData.bimOther.trim())
        );
    };

    return (
        <div className="step3">
            <div className="step3__container">
                <div className="step3__header">
                    <h2 className="step3__title">Detalles del Alcance</h2>
                    <p className="step3__subtitle">
                        Especifica las áreas, disciplinas y entregables de tu
                        proyecto
                    </p>
                </div>

                <form className="step3__form" onSubmit={handleSubmit}>
                    <div className="form-card">
                        <div className="form-card__header">
                            <h3 className="form-card__title">
                                Áreas a Escanear *
                            </h3>
                            <span className="form-card__count">
                                {formData.areasToScan.length} seleccionada
                                {formData.areasToScan.length !== 1 ? "s" : ""}
                            </span>
                        </div>

                        {errors.areasToScan && (
                            <p className="error-message">
                                {errors.areasToScan}
                            </p>
                        )}

                        <div className="checkbox-grid">
                            {areasOptions.map((area) => (
                                <label key={area} className="checkbox-card">
                                    <input
                                        type="checkbox"
                                        checked={formData.areasToScan.includes(
                                            area
                                        )}
                                        onChange={() =>
                                            handleCheckboxChange(
                                                "areasToScan",
                                                area
                                            )
                                        }
                                    />
                                    <span className="checkbox-card__box"></span>
                                    <span className="checkbox-card__label">
                                        {area}
                                    </span>
                                </label>
                            ))}
                        </div>

                        {formData.areasToScan.includes("Otro") && (
                            <div className="other-input-card">
                                <input
                                    type="text"
                                    name="areasOther"
                                    value={formData.areasOther}
                                    onChange={handleInputChange}
                                    placeholder="Especifica otras áreas..."
                                    className={errors.areasOther ? "error" : ""}
                                />
                                {errors.areasOther && (
                                    <span className="error-text">
                                        {errors.areasOther}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="form-card">
                        <div className="form-card__header">
                            <h3 className="form-card__title">
                                Disciplinas de Interés
                            </h3>
                            <span className="form-card__badge">Opcional</span>
                        </div>

                        <div className="checkbox-grid checkbox-grid--compact">
                            {disciplinesOptions.map((discipline) => (
                                <label
                                    key={discipline}
                                    className="checkbox-card"
                                >
                                    <input
                                        type="checkbox"
                                        checked={formData.disciplines.includes(
                                            discipline
                                        )}
                                        onChange={() =>
                                            handleCheckboxChange(
                                                "disciplines",
                                                discipline
                                            )
                                        }
                                    />
                                    <span className="checkbox-card__box"></span>
                                    <span className="checkbox-card__label">
                                        {discipline}
                                    </span>
                                </label>
                            ))}
                        </div>

                        {formData.disciplines.includes("Otro") && (
                            <div className="other-input-card">
                                <input
                                    type="text"
                                    name="disciplinesOther"
                                    value={formData.disciplinesOther}
                                    onChange={handleInputChange}
                                    placeholder="Especifica otras disciplinas..."
                                    className={
                                        errors.disciplinesOther ? "error" : ""
                                    }
                                />
                                {errors.disciplinesOther && (
                                    <span className="error-text">
                                        {errors.disciplinesOther}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="form-card">
                        <div className="form-card__header">
                            <h3 className="form-card__title">
                                Entregables de Escaneo
                            </h3>
                            <span className="form-card__badge">Opcional</span>
                        </div>

                        <div className="checkbox-grid checkbox-grid--compact">
                            {scanningDeliverablesOptions.map((deliverable) => (
                                <label
                                    key={deliverable}
                                    className="checkbox-card"
                                >
                                    <input
                                        type="checkbox"
                                        checked={formData.scanningDeliverables.includes(
                                            deliverable
                                        )}
                                        onChange={() =>
                                            handleCheckboxChange(
                                                "scanningDeliverables",
                                                deliverable
                                            )
                                        }
                                    />
                                    <span className="checkbox-card__box"></span>
                                    <span className="checkbox-card__label">
                                        {deliverable}
                                    </span>
                                </label>
                            ))}
                        </div>

                        {formData.scanningDeliverables.includes("Otro") && (
                            <div className="other-input-card">
                                <input
                                    type="text"
                                    name="scanningOther"
                                    value={formData.scanningOther}
                                    onChange={handleInputChange}
                                    placeholder="Especifica otros entregables..."
                                    className={
                                        errors.scanningOther ? "error" : ""
                                    }
                                />
                                {errors.scanningOther && (
                                    <span className="error-text">
                                        {errors.scanningOther}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="form-card">
                        <div className="form-card__header">
                            <h3 className="form-card__title">
                                Entregables BIM
                            </h3>
                            <span className="form-card__badge">Opcional</span>
                        </div>

                        <div className="checkbox-grid checkbox-grid--compact">
                            {bimDeliverablesOptions.map((deliverable) => (
                                <label
                                    key={deliverable}
                                    className="checkbox-card"
                                >
                                    <input
                                        type="checkbox"
                                        checked={formData.bimDeliverables.includes(
                                            deliverable
                                        )}
                                        onChange={() =>
                                            handleCheckboxChange(
                                                "bimDeliverables",
                                                deliverable
                                            )
                                        }
                                    />
                                    <span className="checkbox-card__box"></span>
                                    <span className="checkbox-card__label">
                                        {deliverable}
                                    </span>
                                </label>
                            ))}
                        </div>

                        {formData.bimDeliverables.includes("Otro") && (
                            <div className="other-input-card">
                                <input
                                    type="text"
                                    name="bimOther"
                                    value={formData.bimOther}
                                    onChange={handleInputChange}
                                    placeholder="Especifica otros entregables BIM..."
                                    className={errors.bimOther ? "error" : ""}
                                />
                                {errors.bimOther && (
                                    <span className="error-text">
                                        {errors.bimOther}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="form-card">
                        <div className="form-card__header">
                            <h3 className="form-card__title">
                                Detalles Adicionales
                            </h3>
                            <span className="form-card__badge">Opcional</span>
                        </div>

                        <textarea
                            name="additionalDetails"
                            value={formData.additionalDetails}
                            onChange={handleInputChange}
                            placeholder="Nivel de detalle, estándares BIM, áreas específicas, etc."
                            rows="6"
                            className="form-textarea"
                        />
                    </div>

                    <div className="form-actions">
                        <Button
                            variant="outline"
                            icon={<HiArrowLeft />}
                            animationType="pop"
                            onClick={(e) => {
                                e.preventDefault();
                                onBack();
                            }}
                        >
                            Volver
                        </Button>

                        <Button
                            variant="filled"
                            icon={<HiArrowRight />}
                            animationType="pop"
                            disabled={!isFormValid()}
                        >
                            Continuar
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Step3;
